module.exports = "/images/vendor/flag-icon-css/flags/4x3/mf.svg?5b9ff36c7fed044c253162373820d80a";